<div [ngClass]="type + '-wrapper'" [ngStyle]="{ 'justify-content': alignment, width: type === 'horisontal' ? length : '1px', height: type === 'horisontal' ? '1px' : length }">
  <div class="line" *ngIf="!withOr" [ngStyle]="{ background: color, width: type === 'horisontal' ? length : '1px', height: type === 'horisontal' ? '1px' : length }"></div>
  <div class="or-line" *ngIf="withOr && type === 'horisontal'" [ngStyle]="{ width: length, 'justify-content': alignment }">
    <div
      class="line"
      [ngStyle]="{
        background: color,
        width: 'calc(50% - 16.5px )',
        height: '1px'
      }"></div>
    <h4 class="h4-semibold">or</h4>
    <div
      class="line"
      [ngStyle]="{
        background: color,
        width: 'calc(50% - 16.5px )',
        height: '1px'
      }"></div>
  </div>
</div>
